import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import ResourceRampCurvesCard from '@/features/resource/components/rampCurves/ResourceRampCurvesCard'
import { ResourceRouteInformation } from '@/features/resource/constants'
import { useResourceDetails } from '@/features/resource/pages/ResourceDetailsPage'

function ResourceRampCurvesPage() {
  const { resourceUuid } = useParams()

  const { setActivePage } = useResourceDetails()

  useEffect(() => {
    setActivePage(ResourceRouteInformation.RESOURCE_RAMP_CURVES.routePath)
  }, [setActivePage])

  if (!resourceUuid) {
    return null
  }

  return <ResourceRampCurvesCard />
}

export default ResourceRampCurvesPage
